<template>
  <tr>
    <th>
      <p class="lib-mt-5 sub-goods-title">
        <label>
          <input type="checkbox"
                 :disabled="isEssentialGoods"
                 v-model="isCheckedSubGoods"
          >
          <span class="ml-5">{{displayName}}</span>
        </label>
      </p>
      <InformationBadge
          v-show="!!informationUrl"
          :information-url="informationUrl"></InformationBadge>
    </th>
    <td :class="{disabled: !isCheckedSubGoods}">

      <div class="hw-input-wrap">
        <input type="number"
               class="hw-input w-40 text-right"
               v-model="localQuantity"
               :min="1"
               :max="maxQuantity"
               :disabled="!isCheckedSubGoods"
        >
        <span class="ml-5">{{volumeUnit}}</span>
        <span class="primary-gray-color ml-10">1~{{ maxQuantity }}까지 1단위 입력</span>
      </div>

    </td>
    <td :class="{disabled: !isCheckedSubGoods}" class="text-right primary-gray-color">
      {{displayRetailPrice | numberFormat}}원/1{{termUnitName}}
    </td>
  </tr>
</template>

<script>
import InformationBadge from "@/components/step1/GoodsTable/SubGoodsTemplate/InformationBadge"

export default {
  name: "Id11",
  components:{
    InformationBadge
  },
  data(){
    return {
      localQuantity : 1,
      localVolume : 1,
      isCheckedSubGoods : false,
    }
  },
  props: {
    subGoodsCompositionInfo: {
      type: Object
    },
    subGoodsInfoList: {
      type: Array,
    },
    displayInfo: {
      type: Object,
    },
    essentialGoodsList: {
      type: Array,
    },
    defaultSelectGoodsList: {
      type: Array,
    },
  },
  watch: {
    isCheckedSubGoods (isChecked) {
      if(isChecked){
        this.addSubGoods()
      } else{
        this.removeSubGoods()
      }
    },
    localQuantity(changeQuantity, localQuantity){
      if(changeQuantity > this.maxQuantity){
        alert(this.perVolume+'부터'+this.maxQuantity+'까지 '+this.perVolume+'단위로 입력해주세요.')
        this.localQuantity = localQuantity
        return false
      }
      this.changeQuantity()
    },
    defaultSelectGoodsList(defaultSelectGoodsList){
      defaultSelectGoodsList.forEach(defaultSelectGoodsInfo => {
        if( parseInt(defaultSelectGoodsInfo.goods_id) === parseInt(this.localSubGoodsInfo.id) ){
          this.isCheckedSubGoods.push(this.localSubGoodsInfo.id)
        }
      })
    },
  },
  computed:{
    isEssentialGoods(){
      let self = this
      let essentialGoodsIdList = []

      this.essentialGoodsList.forEach(essentialGoodsInfo => {
        essentialGoodsIdList.push(essentialGoodsInfo.goods_id)
      })

      let isEssentialGoods = essentialGoodsIdList.includes(
          parseInt(this.localSubGoodsInfo.id)
      )
      if(isEssentialGoods){
        self.isCheckedSubGoods = true
      }

      return isEssentialGoods
    },
    isDefaultSelectGoods(){
      let defaultSelectGoodsIdList = []

      this.defaultSelectGoodsList.forEach(defaultSelectGoodsInfo => {
        defaultSelectGoodsIdList.push(defaultSelectGoodsInfo.goods_id)
      })

      return defaultSelectGoodsIdList.includes(
          parseInt(this.localSubGoodsInfo.id)
      )
    },
    mainGoodsId(){
      return parseInt(this.subGoodsCompositionInfo.main_goods_id)
    },
    localSubGoodsInfo(){
      return this.subGoodsInfoList[0] ? this.subGoodsInfoList[0] : {}
    },
    perVolume(){
      return parseInt(this.localSubGoodsInfo.resources[0]['volume'])
    },
    displayName(){
      return this.subGoodsCompositionInfo.rule.display_name
    },
    informationUrl() {
      return this.displayInfo.data
    },
    maxQuantity () {
      return parseInt(this.localSubGoodsInfo.max_quantity)
    },
    displayRetailPrice(){
      if(this.localQuantity){
        return this.retailPrice * this.localQuantity
      }
      return this.retailPrice
    },
    retailPrice(){
      return this.localSubGoodsInfo.retail_price
    },
    termUnitName(){
      return this.localSubGoodsInfo.term_unit_name
    },
    volumeUnit(){ // resources를 정렬한 것 중 첫번째의 volume_unit이 단위
      return this.localSubGoodsInfo.resources[0]['volume_unit']
    },
    sort(){
      return parseInt(this.subGoodsCompositionInfo.sort)
    }
  },
  methods:{
      addSubGoods(){
        this.$emit('add-sub-goods', {
          main_goods_id: this.mainGoodsId,
          id: this.localSubGoodsInfo.id,
          quantity: parseInt(this.localQuantity),
          volume: this.localVolume,
          cost: this.retailPrice,
          per_volume: this.perVolume,
          sort: this.sort,
          name : this.displayName,
          volume_unit : this.volumeUnit,
          term_unit : this.localSubGoodsInfo.term_unit,
        })
      },
      removeSubGoods(){
        this.$emit('remove-sub-goods', this.localSubGoodsInfo.id)
      },
      changeQuantity(){
        this.$emit('change-quantity', {
          id: this.localSubGoodsInfo.id,
          quantity: parseInt(this.localQuantity),
        })
      },
  }
}
</script>

<style scoped>
.sub-goods-title{
  float:left;
}
</style>